import type { Configuration } from '@/config/types'
import CookieBotScript from '@/scopes/common/components/Scripts/CookieBotScript'
import GTMScript from '@/scopes/common/components/Scripts/GTMScript'
import NewrelicScript from '@/scopes/common/components/Scripts/NewrelicScript'
import OptimizelyScript from '@/scopes/common/components/Scripts/OptimizelyScript'
import * as React from 'react'

export function ThirdPartyScripts({ configuration }: { configuration: Configuration['thirdParties'] }) {
  const newRelicScriptName = process.env.NEXT_PUBLIC_NEWRELIC_SCRIPT_NAME
  const { cookieBotId, optimizelyId, gtmId } = configuration

  return (
    <>
      {/* Cookiebot must be loaded first in order to be able to block other scripts */}
      <CookieBotScript cookieBotId={cookieBotId} />
      <GTMScript gtmId={gtmId} />
      <OptimizelyScript optimizelyKey={optimizelyId} />
      <NewrelicScript newRelicScriptName={newRelicScriptName!} />
    </>
  )
}
